import { Converter, productionEnvName, getClientPortalBaseUrls } from '@itm/shared-frontend/lib/utils';
import getEnvVariable from './getEnvVariable';

import {
  TargetPlatform,
  ParameterStatus,
  UploadStatus,
  AnalysisStatus,
  SetupStatus,
  UploadHistoryStatus,
  ValidationType,
  TemplateStatus,
  TemplateType,
  ReportStatus,
  ValidationRunType,
  ValidationStatus,
  ExportToSftpFormat,
  SelectOption,
  SchemeAuditAction,
  SchemeAuditArea,
} from 'src/types';

export const ENV_PREFIX = 'REACT_APP_' as const;

export const ENVIRONMENT = getEnvVariable('ENVIRONMENT');
export const TARGET_PLATFORM = getEnvVariable('TARGET_PLATFORM');
export const AUTH_API_URL = getEnvVariable('AUTH_API_URL');
export const DATA_AUDIT_API_URL = getEnvVariable('DATA_AUDIT_API_URL');
export const CLIENT_PORTAL_API_URL = getEnvVariable('CLIENT_PORTAL_API_URL');

export const isProductionEnv = ENVIRONMENT === productionEnvName;
export const isAzureTargetPlatform = TARGET_PLATFORM === TargetPlatform.AZURE;

export const { clientPortalDomain, clientPortalLoginUrl, clientPortalDashboardUrl } =
  getClientPortalBaseUrls(ENVIRONMENT);

export const parameterStatusOptions = Converter.enumToSelectOptions(ParameterStatus);
export const uploadStatusOptions = Converter.enumToSelectOptions(UploadStatus);
export const analysisStatusOptions = Converter.enumToSelectOptions(AnalysisStatus);
export const benefitSectionSetupStatusOptions = Converter.enumToSelectOptions(SetupStatus);
export const uploadHistoryStatusOptions = Converter.enumToSelectOptions(UploadHistoryStatus);
export const validationTypeOptions = Converter.enumToSelectOptions(ValidationType);
export const templateStatusOptions = Converter.enumToSelectOptions(TemplateStatus);
export const templateTypeOptions = Converter.enumToSelectOptions(TemplateType);
export const reportStatusOptions = Converter.enumToSelectOptions(ReportStatus);
export const analysisRunTypeOptions = Converter.enumToSelectOptions(ValidationRunType);
export const analysisRunStatusOptions = Converter.enumToSelectOptions(ValidationStatus);

export const schemeAuditAreaOptions: SelectOption[] = [
  { value: SchemeAuditArea.SchemeDetail, label: 'Scheme details' },
  { value: SchemeAuditArea.BenefitSection, label: 'Benefit sections' },
  { value: SchemeAuditArea.PensionElement, label: 'Pension elements' },
  { value: SchemeAuditArea.Tranches, label: 'Tranches' },
  { value: SchemeAuditArea.TranchesBulkUpload, label: 'Tranches bulk upload' },
];

export const schemeAuditActionOptions: SelectOption[] = Converter.enumToSelectOptions(SchemeAuditAction);

export const exportToSftpFormatOptions: SelectOption[] = [
  { value: ExportToSftpFormat.ValidationResults, label: 'Member level validation failure report' },
  { value: ExportToSftpFormat.ValidationViews, label: 'Validation level detailed output files' },
  { value: ExportToSftpFormat.Both, label: 'Both reports' },
];
